module.exports = __webpack_public_path__ + "static/media/npm.5d61721a.png";